import React, { useEffect, useState } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Grid } from 'react-flexbox-grid';
import NotesList from './NotesList';
import { getMeetingNotesByProjectId } from '../../../api';
import { spinnerOff, spinnerOn } from '../../../components/Spinner';
import MeetingNote from './MeetingNote';
import 'containers/startproj/MeetingNotes/meeting_notes.css';

function MeetingNotes(props) {
    const {location, project, status, refreshNotes, setRefreshNotes} = props;

    const [meetingNotesList, setMeetingNotesList] = useState([]);
    const [refresh, setRefresh] = useState(true);

    useEffect(() => {
        async function getData() {
            spinnerOn();
            const notesList = await getMeetingNotesByProjectId(project.id);
            setMeetingNotesList(notesList);
            spinnerOff();
            setRefresh(false);
            setRefreshNotes(false);
        }

        if (refreshNotes || refresh) getData();
    }, [refresh, refreshNotes]);

    async function handleRefreshCall() {
        setRefresh(true);
        props.history.push(`/${status}/${project.id}/notes`);
    }

    return (
      <Grid fluid>
          <Switch location={location}>
              <Route
                exact
                key="list"
                path={`/:status/:projectId/notes`}
                component={() =>
                  <NotesList project={project}
                             status={status}
                             meetingNotesList={meetingNotesList}
                             //history={history}
                             handleRefreshCall={handleRefreshCall}
                             refreshNotes={refreshNotes}
                             refresh={refresh}
                  />
                }
              />
              <Route
                exact
                key="note"
                path={`/:status/:projectId/notes/:id`}
                component={() =>
                  <MeetingNote project={project}
                               status={status}
                               viewOnly={false}
                               //history={history}
                               handleRefreshCall={handleRefreshCall}
                  />
                }
              />
              <Route
                  exact
                  key="note"
                  path={`/:status/:projectId/notes/:id/view`}
                  component={() =>
                      <MeetingNote project={project}
                                   status={status}
                                   viewOnly={true}
                                   //history={history}
                                   handleRefreshCall={handleRefreshCall}
                      />
                  }
              />
          </Switch>
      </Grid>
    );
}

export default withRouter(MeetingNotes);
